import { configureStore } from "@reduxjs/toolkit";
import { productApi } from "./api/productsApi";
import { authApi } from "./api/authApi";
import { userApi } from "./api/userApi";
import { orderApi } from "./api/orderApi";
import viewedProductsReducer from "./slices/viewedProductsSlice";
import userReducer from "./slices/userSlice";
import cartReducer from "./slices/cartSlice";
import uiReducer  from "./slices/uiSlice";
import { wishlistApi } from "./api/wishlistApi";
import { blogApi } from "./api/blogsApi";


export const store = configureStore({
  reducer: {
    auth: userReducer,
    cart: cartReducer,
    ui: uiReducer,
   
    [productApi.reducerPath]: productApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [wishlistApi.reducerPath]: wishlistApi.reducer,
    [blogApi.reducerPath]:blogApi.reducer,
    viewedProducts: viewedProductsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      productApi.middleware,
      authApi.middleware,
      userApi.middleware,
      orderApi.middleware,
      wishlistApi.middleware,
      blogApi.middleware
    ]),
});
